var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4135",
    "data-name": "Group 4135",
    transform: "translate(-432 -887.996)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1042",
    "data-name": "Ellipse 1042",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(432 887.996)",
    fill: "#030852"
  }), /*#__PURE__*/React.createElement("g", {
    id: "archive-tray-fill",
    transform: "translate(453.955 909.996)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1436",
    "data-name": "Rectangle 1436",
    width: 28,
    height: 28,
    transform: "translate(0.045)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9437",
    "data-name": "Path 9437",
    d: "M51.69,32h-17.9a1.793,1.793,0,0,0-1.79,1.79v12.52s0,.009,0,.013,0,.009,0,.013V51.7a1.793,1.793,0,0,0,1.79,1.79h17.9a1.793,1.793,0,0,0,1.79-1.79V33.79A1.793,1.793,0,0,0,51.69,32ZM38.307,41a.9.9,0,0,1,1.266,0l2.27,2.27V36.476a.9.9,0,1,1,1.79,0v6.791L45.9,41a.9.9,0,1,1,1.266,1.266l-3.8,3.8-.019.017c-.015.014-.03.028-.046.041l-.023.017c-.016.012-.031.024-.047.035l-.019.012c-.018.012-.037.023-.056.033l-.015.007c-.021.011-.043.021-.065.031l-.01,0c-.024.01-.048.018-.073.026l-.01,0c-.025.007-.049.014-.075.019l-.022,0c-.021,0-.043.007-.065.01a.883.883,0,0,1-.179,0c-.022,0-.043-.006-.065-.01l-.022,0c-.025-.005-.05-.012-.075-.019l-.01,0c-.025-.008-.049-.017-.073-.026l-.01,0c-.022-.009-.044-.02-.065-.031l-.014-.007c-.019-.01-.038-.022-.056-.033l-.019-.012c-.016-.011-.032-.023-.047-.035l-.023-.017c-.015-.013-.03-.027-.044-.04l-.02-.018-3.8-3.8A.9.9,0,0,1,38.307,41ZM51.69,51.7h-17.9V47.219h3.21l2.161,2.162a1.779,1.779,0,0,0,1.266.524h4.63a1.779,1.779,0,0,0,1.266-.524l2.161-2.161h3.212V51.7Z",
    transform: "translate(-28.517 -28.419)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.2e322aa2635c90ba3aebebe9cc171164.svg";
export { ForwardRef as ReactComponent };